customElements.get("geolocation-popup") || customElements.define("geolocation-popup", class extends HTMLElement {
  static sessionKey="geolocation-popup-dismissed";
  constructor() {
    super(), this.detectedCountry = null, this.closeButton = this.querySelector("[data-geolocation-close]"), 
    this.form = this.querySelector("form"), this.detectedCountryElement = this.querySelector("[data-geolocation-detected-country]"), 
    this.selectElement = this.querySelector("[data-geolocation-select]"), this.endpoint = this.dataset.endpoint, 
    this.currentCountryCode = this.dataset.currentCountryCode;
  }
  connectedCallback() {
    this.endpoint && this.currentCountryCode && (sessionStorage.getItem(this.constructor.sessionKey) || (this.addEventListeners(), 
    this.detectLocation()));
  }
  addEventListeners() {
    this.closeButton?.addEventListener("click", () => this.dismiss()), this.form?.addEventListener("submit", () => this.dismiss());
  }
  async detectLocation() {
    try {
      const t = await fetch(this.endpoint);
      if (!t.ok) return;
      const {detected_values: e} = await t.json();
      if (this.detectedCountry = e?.country, !this.detectedCountry || this.detectedCountry.handle === this.currentCountryCode) return;
      this.show(this.detectedCountry.name);
    } catch (t) {
      console.warn("[GeolocationPopup] Failed to detect location:", t);
    }
  }
  show(t) {
    this.detectedCountryElement && (this.detectedCountryElement.textContent = t), this.selectElement && (this.selectElement.value = this.detectedCountry.handle), 
    this.hidden = !1, this.classList.remove("hidden"), this.classList.add("flex");
  }
  dismiss() {
    sessionStorage.setItem(this.constructor.sessionKey, "true"), this.hidden = !0, this.classList.add("hidden"), 
    this.classList.remove("flex");
  }
});